import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AssetStateMessage } from '@r1-compass-library/models';
import { RoutingService } from '@r1-compass-library/services/routing.service';
import { SnackBarService } from '@r1-compass-library/services/snack-bar.service';
import { ErrorHandlingService } from './error-handling.service';

@Injectable({
    providedIn: 'root',
})
export class AssetStateMessageHandlingService {
    readonly #snackBarService = inject(SnackBarService);
    readonly #route = inject(ActivatedRoute);
    readonly #router = inject(Router);
    readonly #routingService = inject(RoutingService);
    readonly #errorHandlingService = inject(ErrorHandlingService);

    handleMessage(message: AssetStateMessage) {
        if (message.type === 'Error') {
            this.#snackBarService.openErrorSnackbar(
                this.#errorHandlingService.createErrorData({
                    messages: [message.message],
                    showDismissButton: true,
                    statusCode: message.statusCode,
                    statusText: message.statusText,
                })
            );
            this.navigateToFolderRoot();
        } else if (message.type === 'Info' || message.type === 'Warning') {
            this.#snackBarService.openGenericSnackbar({
                messages: [message.message],
                showDismissButton: true,
            });
        }
    }

    private navigateToFolderRoot() {
        this.#router.navigate([this.#routingService.topRoute()], {
            relativeTo: this.#route,
            queryParams: { folderId: 0 },
        });
    }
}
